import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';

function Home() {
  return (
    <div className="home-page">
      <section className="hero-section">
        <div className="hero-content">
          <h1>NU Blockchain Group</h1>
          <h2>Pioneering the Future of Blockchain Technology</h2>
          <p>Join Northwestern's premier student organization exploring decentralized systems, cryptocurrencies, and blockchain applications.</p>
          <div className="hero-buttons">
            <Link to="/contact" className="primary-btn">Join Our Community</Link>
            <Link to="/about" className="secondary-btn">Learn More</Link>
          </div>
        </div>
      </section>

      <section className="features-section container">
        <h2 className="section-title">What We Offer</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">📚</div>
            <h3>Educational Workshops</h3>
            <p>Learn blockchain fundamentals and advanced concepts through our regular workshops and seminars.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔗</div>
            <h3>Industry Connections</h3>
            <p>Connect with leading professionals and companies in the blockchain ecosystem.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🚀</div>
            <h3>Research Initiatives</h3>
            <p>Participate in cutting-edge blockchain research projects and hackathons.</p>
          </div>
        </div>
      </section>
      
      <section className="join-section">
        <div className="container">
          <div className="join-content">
            <h2>Become a Member Today</h2>
            <p>Join a community of innovators, developers, and blockchain enthusiasts at Northwestern University.</p>
            <Link to="/contact" className="join-btn">Get Started</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home